import { render } from "./GoalScoringHalfTime.vue?vue&type=template&id=706b01ae&scoped=true"
import script from "./GoalScoringHalfTime.vue?vue&type=script&lang=js"
export * from "./GoalScoringHalfTime.vue?vue&type=script&lang=js"

import "./GoalScoringHalfTime.vue?vue&type=style&index=0&id=706b01ae&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706b01ae"]])

export default __exports__